export function hasRequiredOnboardingContacts(email, phone) {
    return email.trim().length > 0 && phone.trim().length > 0;
}
